<template>
    <LoadingCard v-if="loading"></LoadingCard>
    <div v-else>
        <Users :role="role" />
    </div>
</template>

<script>
import currentUserQuery from '@views/Users/queryCurrentUser.graphql';

import Users from '../Users/Browse.vue';

export default {
  name: 'UsersContainer',
  props: ['role'],
  components: {
    Users,
  },
  apollo: {
    currentUser: {
      query: currentUserQuery,
    },
  },
  watch: {
    currentUser() {
      const validRole = ['developer', 'admin'].includes(this.currentUser.role.name);

      if (!validRole) {
        this.$notifyFailure('Not allowed.');
        setTimeout(() => this.$router.push({ name: 'dashboard' }), this.$redirectTimeout);
      }
    },
  },
  data() {
    return {
      currentUser: null,
      loading: 0,
    };
  },
};
</script>
